import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { ClusterTableColumn } from "../../../Data/DataTables/Cluster";
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewCluster } from "../../../Types/CompanyProfile/Cluster";

//Modal
import CreateClusterModal from "../../UiKits/Modal/Cluster/Create";

//Services
import {
  VIEW_CLUSTER_QUERY_KEY,
  clusterService,
} from "../../../Services/clusterService";
import cluster from "cluster";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const ClusterTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const QueryKey = [...VIEW_CLUSTER_QUERY_KEY, company_code];

  const { data: Data = [], isLoading: isLoading } = useQuery<ViewCluster[]>({
    queryKey: QueryKey,
    queryFn: () =>
      clusterService.getAllViewClusterByCompany(company_code as string),
  });

  const filteredItems: ViewCluster[] = Data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Cluster Maintenance</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Allows users to create, update, and manage cluster records to keep
        operational data accurate and up to date.
      </P>
      <CreateClusterModal company_code={company_code} />
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={ClusterTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default ClusterTable;
